var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"placement":"left","closable":false,"visible":_vm.visible},on:{"close":_vm.onClose}},[_c('div',{staticClass:"drawer-left"},[_c('LeftMenu',{attrs:{"isDrawer":""},on:{"drawerChange":_vm.onClose}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }